import { productSearch } from "./commerce";

// -----------------------------------------------------------------------------
// CATEGORIES
// -----------------------------------------------------------------------------
export const CATEGORIES = [
  {
    slug: "capelli-tools",
    label: "Capelli tools",
    number: "01",
    description:
      "Spazzole, phon, piastre e diffusori scelti per rendere la routine capelli più corta — non più complicata.",
    image:
      "https://images.unsplash.com/photo-1527799820374-dcf8d9d4a388?q=85&w=1600&auto=format&fit=crop",
  },
  {
    slug: "viso-tools",
    label: "Viso tools",
    number: "02",
    description:
      "Utensili viso onesti: rulli, spugnette, pennelli. Nessun claim medico, nessuna promessa impossibile.",
    image:
      "https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?q=85&w=1600&auto=format&fit=crop",
  },
  {
    slug: "organizer-vanity",
    label: "Organizer vanity",
    number: "03",
    description:
      "Contenitori, vassoi girevoli, divisori: tutto quello che serve per una vanity che funziona davvero.",
    image:
      "https://images.unsplash.com/photo-1512496015851-a90fb38ba796?q=85&w=1600&auto=format&fit=crop",
  },
  {
    slug: "travel-beauty",
    label: "Travel beauty",
    number: "04",
    description:
      "Pouch, mini formati e organizer da viaggio per portare la routine essenziale ovunque, senza caos.",
    image:
      "https://images.unsplash.com/photo-1513127832320-b594b8bc38f3?q=85&w=1600&auto=format&fit=crop",
  },
  {
    slug: "under-30",
    label: "Under €30",
    number: "05",
    description:
      "Il meglio sotto i trenta euro: tool e organizer con rapporto prezzo-durata davvero sensato.",
    image:
      "https://images.unsplash.com/photo-1701686794670-379e5a943a96?q=85&w=1600&auto=format&fit=crop",
  },
  {
    slug: "best-of",
    label: "Best of",
    number: "06",
    description:
      "Le scelte che consigliamo come prime: testate, provate, tenute su una vanity vera per almeno tre mesi.",
    image:
      "https://images.unsplash.com/photo-1512496015851-a90fb38ba796?q=85&w=1600&auto=format&fit=crop",
  },
];

// -----------------------------------------------------------------------------
// GUIDES – 6 editorial guides (Italian, ≥ 300 words each)
// -----------------------------------------------------------------------------
export const GUIDES = [
  {
    slug: "vanity-organizzata-in-20-minuti",
    title: "Vanity organizzata in 20 minuti",
    kicker: "Setup",
    readMinutes: 6,
    date: "Novembre 2025",
    cover:
      "https://images.unsplash.com/photo-1512496015851-a90fb38ba796?q=85&w=1800&auto=format&fit=crop",
    excerpt:
      "Un metodo semplice per rimettere ordine nella vanity senza comprare mobili nuovi. Solo tre gesti, un timer e un vassoio.",
    intro:
      "Riorganizzare la vanity non è una questione di mobili: è una questione di gesti. Venti minuti bastano per capire quali prodotti usi davvero, quali stanno solo occupando spazio e come disporre i tool nella zona che raggiungi in primo piano.",
    sections: [
      {
        heading: "01. Svuota tutto su un telo chiaro",
        body:
          "Sposta ogni cosa dal piano della vanity a un telo o un asciugamano chiaro appoggiato per terra. Vedere i prodotti tutti insieme, fuori dal loro contenitore abituale, cambia completamente la percezione: capisci subito quanti duplicati hai e quanti prodotti sono in scadenza. Non serve pulire ora: serve vedere.",
      },
      {
        heading: "02. Dividi in tre gruppi: ogni giorno, ogni settimana, mai",
        body:
          "Fai tre pile fisiche. \u00abOgni giorno\u00bb sono i cinque-sei prodotti che usi davvero senza pensare. \u00abOgni settimana\u00bb sono maschere, esfolianti, tool viso, smalti. \u00abMai\u00bb sono i prodotti che tieni per senso di colpa: regalali, testali una volta ancora entro sette giorni o eliminali. La vanity ordinata comincia da questa onestà.",
      },
      {
        heading: "03. Ricomponi con un vassoio e un organizer verticale",
        body:
          "Il vassoio delimita la zona quotidiana: contiene ciò che tocchi ogni mattina e ogni sera. L'organizer verticale — meglio se in vetro o acrilico trasparente — ospita pennelli e tool. Tutto il resto va in un cassetto suddiviso con divisori bassi. Regola d'oro: il piano libero deve restare almeno per due terzi.",
      },
    ],
    takeaways: [
      "20 minuti, non un pomeriggio.",
      "Tre gruppi: ogni giorno, ogni settimana, mai.",
      "Il piano libero è il vero indicatore di ordine.",
    ],
    related: ["bagno-piccolo-hotel-look-beauty", "errori-organizer-inutili"],
  },
  {
    slug: "bagno-piccolo-hotel-look-beauty",
    title: "Bagno piccolo, look da hotel",
    kicker: "Setup",
    readMinutes: 5,
    date: "Ottobre 2025",
    cover:
      "https://images.unsplash.com/photo-1760749124145-8ceea3f541b5?q=85&w=1800&auto=format&fit=crop",
    excerpt:
      "Come ottenere l'estetica pulita di un boutique hotel in un bagno di quattro metri quadri, senza rinunciare a nulla di quello che usi davvero.",
    intro:
      "Il segreto del \u00ablook hotel\u00bb non è avere marmo ovunque: è la ripetizione. Contenitori identici, materiali pochi, superfici sempre libere. In un bagno piccolo il risultato è ancora più netto — a patto di seguire tre principi molto semplici.",
    sections: [
      {
        heading: "01. Travasa in flaconi ricaricabili in vetro fumé",
        body:
          "Shampoo, balsamo, bagnoschiuma, detergente viso: quattro flaconi identici da 250 ml in vetro fumé o ambrato eliminano il rumore visivo delle etichette. Etichetta minimal, scritta a mano o in stampatello sottile. In un bagno piccolo, meno colori sul piano = più spazio percepito.",
      },
      {
        heading: "02. Una sola texture per gli accessori",
        body:
          "Scegli un unico materiale — ottone spazzolato, acciaio nero opaco o legno chiaro — e ripeti su porta-spazzolino, portasapone, appendiabiti. La coerenza materica sostituisce la grandezza dello spazio: l'occhio legge \u00abinsieme curato\u00bb.",
      },
      {
        heading: "03. Un vassoio, un asciugamano, una candela",
        body:
          "Sopra il lavandino un vassoio piccolo con tre oggetti al massimo. Un asciugamano piegato tondo in nicchia. Una candela non profumata se il bagno è cieco. Questi tre gesti da soli valgono più di qualsiasi ristrutturazione.",
      },
    ],
    takeaways: [
      "Ripeti materiali e formati.",
      "Travasi in vetro fumé = zero rumore visivo.",
      "Tre oggetti sul lavandino, non di più.",
    ],
    related: ["vanity-organizzata-in-20-minuti", "travel-pouch-essenziale"],
  },
  {
    slug: "travel-pouch-essenziale",
    title: "Travel pouch essenziale: la routine in 5 tool",
    kicker: "Travel",
    readMinutes: 4,
    date: "Ottobre 2025",
    cover:
      "https://images.unsplash.com/photo-1513127832320-b594b8bc38f3?q=85&w=1800&auto=format&fit=crop",
    excerpt:
      "Cosa mettere davvero nel beauty da viaggio se stai fuori tre notti. Cinque tool, una pouch trasparente, zero flaconi mai usati.",
    intro:
      "Le pouch fanno tutte più o meno la stessa cosa. La differenza la fa cosa ci metti dentro. Per tre notti bastano cinque tool ben pensati e i mini-formati dei prodotti che usi già a casa — non nuovi acquisti fatti in aeroporto.",
    sections: [
      {
        heading: "Cosa mettere davvero",
        body:
          "Una spazzola piccola pieghevole, un mini phon da viaggio se dormi in B&B, una spugnetta per fondotinta, una pinzetta e un pennello multiuso. Aggiungi cinque mini-flaconi (100 ml massimo) di detergente, crema viso, contorno occhi, shampoo secco e struccante. Fine.",
      },
      {
        heading: "La pouch giusta",
        body:
          "Trasparente in TPU o mesh, con doppia zip. La trasparenza serve al controllo di sicurezza in aeroporto e serve a te: se vedi tutto, ti dimentichi meno. Evita pouch imbottite spesse: rubano spazio senza proteggere davvero.",
      },
      {
        heading: "La regola dello spazio residuo",
        body:
          "Se la pouch si chiude a fatica, hai messo troppo. Deve restare almeno il 15% di spazio libero: è lì che entrano i souvenir, il piccolo profumo comprato in vacanza, la crema mani in omaggio dell'hotel.",
      },
    ],
    takeaways: [
      "5 tool, non 15.",
      "Pouch trasparente, doppia zip.",
      "15% di spazio libero è la regola.",
    ],
    related: ["routine-minimal-5-tool", "vanity-organizzata-in-20-minuti"],
  },
  {
    slug: "routine-minimal-5-tool",
    title: "Routine minimal: cinque tool che bastano davvero",
    kicker: "Routine",
    readMinutes: 5,
    date: "Settembre 2025",
    cover:
      "https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?q=85&w=1800&auto=format&fit=crop",
    excerpt:
      "Se dovessi ricominciare da capo, comprando solo cinque tool per una routine completa mattina e sera, quali sceglieresti? Ecco la nostra lista.",
    intro:
      "Il minimalismo beauty non è comprare meno per moda: è capire quali oggetti fanno il lavoro di tre. Questi cinque tool coprono capelli, viso, corpo, unghie e trucco in modo credibile — senza mai promettere risultati che nessun accessorio può dare.",
    sections: [
      {
        heading: "01. Spazzola paddle in legno",
        body:
          "Distende senza tirare, distribuisce il sebo lungo la lunghezza (utile per lavaggi meno frequenti) e dura anni. Cerca setole miste (naturale + nylon), manico ergonomico, base ventilata.",
      },
      {
        heading: "02. Pennello multiuso a lingua di gatto",
        body:
          "Uno solo, ben fatto. Stende fondotinta, applica ciprie, sfuma blush. Le fibre sintetiche sono più igieniche e si lavano in un minuto.",
      },
      {
        heading: "03. Rullo viso in metallo freddo",
        body:
          "Non è magia: sgonfia visivamente la mattina, sostituisce il classico cucchiaio in freezer, aiuta a distribuire creme. Nessun claim medico — solo un gesto che funziona in cinque minuti.",
      },
      {
        heading: "04. Tagliaunghie in acciaio buono",
        body:
          "Un solo tagliaunghie fatto bene dura vent'anni. Preferisci acciaio inox, manico solido, lama non curva.",
      },
      {
        heading: "05. Spugnetta doppia per fondotinta",
        body:
          "Estremità arrotondata per grandi zone, punta per contorno naso e occhi. Lavabile, sostituisce due strumenti separati.",
      },
    ],
    takeaways: [
      "Cinque tool coprono l'80% delle esigenze.",
      "Meglio pochi oggetti fatti bene che tanti mediocri.",
      "Il minimalismo non è restrizione, è priorità.",
    ],
    related: ["come-scegliere-spazzola", "travel-pouch-essenziale"],
  },
  {
    slug: "come-scegliere-spazzola",
    title: "Come scegliere una spazzola (davvero)",
    kicker: "Capelli",
    readMinutes: 7,
    date: "Settembre 2025",
    cover:
      "https://images.unsplash.com/photo-1527799820374-dcf8d9d4a388?q=85&w=1800&auto=format&fit=crop",
    excerpt:
      "Setole naturali o sintetiche? Paddle o rotonda? Legno o ceramica? Guida onesta per non comprare la quarta spazzola sbagliata dell'anno.",
    intro:
      "La spazzola giusta dipende da tre cose: il tuo tipo di capello, cosa vuoi ottenere e quanto lo vuoi fare velocemente. Nessuna spazzola è \u00abmigliore in assoluto\u00bb — ma alcune combinazioni sono chiaramente sbagliate.",
    sections: [
      {
        heading: "Capelli fini",
        body:
          "Setole miste (naturale + nylon) e paddle rettangolare. Le setole in cinghiale distribuiscono il sebo lungo la fibra: se lavi due volte a settimana, la spazzola diventa parte della routine e riduce il ricorso allo shampoo secco.",
      },
      {
        heading: "Capelli spessi o ricci",
        body:
          "Denti larghi, meglio se in legno o corno. Le spazzole a paddle piccole non riescono a passare in profondità: cercano solo il volume in superficie e spezzano. Per il post-doccia, usa un pettine a denti larghi prima di qualsiasi spazzola.",
      },
      {
        heading: "Piega con phon",
        body:
          "Spazzola rotonda in ceramica per volume alla radice, diametro medio (32-42 mm) per lunghezze medie. La ceramica trattiene calore e riduce il tempo di asciugatura. Manico antiscivolo: è la differenza tra piega comoda e polso rotto.",
      },
      {
        heading: "Errori comuni",
        body:
          "Comprare la spazzola \u00abvirale\u00bb senza considerare il proprio capello. Usare la stessa spazzola per districare bagnato e per piega finita: sono due gesti diversi. Non pulire mai la spazzola: il sebo residuo la rende inefficace in poche settimane.",
      },
    ],
    takeaways: [
      "Il tipo di capello viene prima del brand.",
      "Setole miste per capelli fini, denti larghi per ricci.",
      "Pulire la spazzola ogni due settimane.",
    ],
    related: ["routine-minimal-5-tool", "errori-organizer-inutili"],
  },
  {
    slug: "errori-organizer-inutili",
    title: "Cinque errori con gli organizer che nessuno ammette",
    kicker: "Organizer",
    readMinutes: 5,
    date: "Agosto 2025",
    cover:
      "https://images.unsplash.com/photo-1512496015851-a90fb38ba796?q=85&w=1800&auto=format&fit=crop",
    excerpt:
      "L'organizer non ordina da solo. Ecco gli errori più comuni: comprare troppo, comprare sbagliato, comprare per il fotografico e non per l'uso.",
    intro:
      "Un organizer che non funziona è peggio del disordine: occupa spazio e ti fa sentire in colpa. La maggior parte degli errori nasce da tre convinzioni sbagliate — e sono più diffuse di quanto sembri.",
    sections: [
      {
        heading: "01. Comprare senza misurare",
        body:
          "Il primo errore. Un organizer da 30 cm nel cassetto da 28 non entra. Misura larghezza, profondità e altezza interna prima di ordinare — e togli sempre un centimetro per il gioco dei divisori.",
      },
      {
        heading: "02. Prendere il set completo per estetica",
        body:
          "I set da undici pezzi coordinati sono bellissimi in foto. Nella pratica ne usi tre. Comincia con un pezzo singolo, testalo per due settimane, poi decidi se estendere.",
      },
      {
        heading: "03. Trasparente sempre e comunque",
        body:
          "Trasparente ha senso quando devi vedere il contenuto (rossetti, pennelli, smalti). Non ha senso per confezioni multicolore che stanno insieme in un cassetto: aggiunge caos visivo. Meglio opaco chiaro o legno.",
      },
      {
        heading: "04. Ignorare la manutenzione",
        body:
          "L'organizer va svuotato e pulito ogni due mesi. Se non lo fai, cipria e polvere si depositano nei divisori e diventa più sporco di prima. Metti un promemoria.",
      },
      {
        heading: "05. Dimenticare la verticale",
        body:
          "Le pareti dei mobili sono sempre libere. Un pannello magnetico o una barra sottile con ganci elimina cinque oggetti dal piano in un secondo.",
      },
    ],
    takeaways: [
      "Misura prima di comprare.",
      "Un pezzo alla volta, non il set intero.",
      "La verticale è lo spazio più sottovalutato.",
    ],
    related: ["vanity-organizzata-in-20-minuti", "come-scegliere-spazzola"],
  },
];

// -----------------------------------------------------------------------------
// PRODUCT LISTS (4 curated lists)
// -----------------------------------------------------------------------------
export const PRODUCT_LISTS = [
  {
    slug: "organizer-make-up-che-funzionano",
    title: "Organizer make-up che funzionano davvero",
    kicker: "Lista aggiornata — Novembre 2025",
    intro:
      "Selezione onesta di organizer per make-up tra 15 e 80 euro, con criteri chiari: materiale che non si graffia, divisori regolabili, base antiscivolo. Solo prodotti con almeno 4 stelle e spedizione veloce disponibile.",
    criteria: [
      "Prezzo tra €15 e €80",
      "Almeno 4★ con ≥500 recensioni",
      "Spedizione veloce disponibile",
      "Materiale non graffiabile",
      "Divisori regolabili o modulari",
    ],
    cover:
      "https://images.unsplash.com/photo-1512496015851-a90fb38ba796?q=85&w=1800&auto=format&fit=crop",
    products: [
      {
        name: "Organizer girevole in acrilico a 360°",
        price: "€ 39,90",
        priceRange: "€35–45",
        rating: "4.6",
        pros: ["Ruota fluidamente", "Cassetti bassi", "Facile da pulire"],
        cons: ["Occupa piano libero"],
        why: "Fa il lavoro di due contenitori. Perfetto per rossetti, mascara e boccette medie.",
        query: "organizer make up girevole acrilico",
        image:
          "https://images.unsplash.com/photo-1560869713-149138cee29f?q=85&w=1000&auto=format&fit=crop",
      },
      {
        name: "Cassettiera acrilica 5 cassetti con divisori",
        price: "€ 54,00",
        priceRange: "€50–65",
        rating: "4.7",
        pros: ["Divisori inclusi", "Impilabile", "Struttura robusta"],
        cons: ["Necessita spazio verticale"],
        why: "L'unico organizer che sostituisce un mobile: ordina fondotinta, ciprie, palette in modo definitivo.",
        query: "cassettiera acrilico make up 5 cassetti",
        image:
          "https://images.unsplash.com/photo-1634449846105-c310f5e06324?q=85&w=1000&auto=format&fit=crop",
      },
      {
        name: "Vassoio in vetro con manici in metallo nero",
        price: "€ 22,50",
        priceRange: "€20–30",
        rating: "4.5",
        pros: ["Estetica editorial", "Facile da spostare", "Compatibile con qualsiasi vanity"],
        cons: ["Pesante quando pieno"],
        why: "Il vassoio giusto trasforma qualsiasi piano in \u00abzona routine\u00bb. Vetro + metallo = zero polvere.",
        query: "vassoio vetro con manici metallo nero",
        image:
          "https://images.unsplash.com/photo-1645075409459-e271a8dd7689?q=85&w=1000&auto=format&fit=crop",
      },
      {
        name: "Divisori regolabili per cassetto (set 4)",
        price: "€ 18,90",
        priceRange: "€15–22",
        rating: "4.4",
        pros: ["Estensibili", "Antiscivolo", "Set completo"],
        cons: ["Da assemblare"],
        why: "Il modo più economico di ordinare un cassetto vanity in cinque minuti.",
        query: "divisori regolabili cassetto make up",
        image:
          "https://images.unsplash.com/photo-1678108040468-0cc9addd984d?q=85&w=1000&auto=format&fit=crop",
      },
      {
        name: "Porta-pennelli in vetro fumé cilindrico",
        price: "€ 16,00",
        priceRange: "€14–20",
        rating: "4.5",
        pros: ["Estetica premium", "Stabile", "Compatibile con perle interne"],
        cons: ["Non lavabile in lavastoviglie"],
        why: "Chiude il set: mette in verticale ciò che di solito è sparso sul piano.",
        query: "porta pennelli vetro fume cilindrico",
        image:
          "https://images.unsplash.com/photo-1620464003286-a5b0d79f32c2?q=85&w=1000&auto=format&fit=crop",
      },
    ],
    faq: [
      {
        q: "Meglio acrilico o vetro?",
        a: "Acrilico se sposti spesso l'organizer o hai bambini in casa. Vetro se cerchi un'estetica più editorial e non muovi mai il pezzo dal piano.",
      },
      {
        q: "Un organizer basta per tutto?",
        a: "Quasi mai. La formula che funziona è: un vassoio piano + un contenitore verticale + divisori nel cassetto. Tre pezzi, non uno solo.",
      },
      {
        q: "Come pulisco l'acrilico senza graffiarlo?",
        a: "Panno microfibra umido con acqua tiepida. Mai spugne abrasive né alcol puro: opacizzano la superficie in modo permanente.",
      },
    ],
  },
  {
    slug: "tool-capelli-essenziali",
    title: "Tool capelli essenziali",
    kicker: "Lista aggiornata — Novembre 2025",
    intro:
      "Cinque strumenti che coprono la piega quotidiana, il volume e il post-doccia. Tutto sotto €80, spedizione veloce, valutazioni verificate.",
    criteria: [
      "Prezzo tra €15 e €80",
      "Almeno 4★ con recensioni consistenti",
      "Spedizione veloce disponibile",
      "Materiali durevoli (ceramica, nylon, legno)",
    ],
    cover:
      "https://images.unsplash.com/photo-1527799820374-dcf8d9d4a388?q=85&w=1800&auto=format&fit=crop",
    products: [
      {
        name: "Spazzola paddle in legno con setole miste",
        price: "€ 24,90",
        priceRange: "€20–30",
        rating: "4.6",
        pros: ["Distribuisce il sebo", "Manico ergonomico", "Base ventilata"],
        cons: ["Non ideale per ricci strutturati"],
        why: "La spazzola quotidiana che riduce lavaggi e migliora la salute apparente del capello.",
        query: "spazzola paddle legno setole miste",
        image:
          "https://images.unsplash.com/photo-1527799820374-dcf8d9d4a388?q=85&w=1000&auto=format&fit=crop",
      },
      {
        name: "Spazzola rotonda ceramica 43 mm",
        price: "€ 32,00",
        priceRange: "€28–40",
        rating: "4.5",
        pros: ["Ceramica termica", "Rotazione fluida", "Buon volume alla radice"],
        cons: ["Curva d'apprendimento iniziale"],
        why: "La rotonda che funziona su lunghezze medie: dà volume senza spezzare.",
        query: "spazzola rotonda ceramica 43mm",
        image:
          "https://images.unsplash.com/photo-1734111719430-fe4a3973f8af?q=85&w=1000&auto=format&fit=crop",
      },
      {
        name: "Phon compatto da viaggio 1600W",
        price: "€ 45,00",
        priceRange: "€40–55",
        rating: "4.5",
        pros: ["Pieghevole", "Doppio voltaggio", "Rumore contenuto"],
        cons: ["Meno potente di modelli fissi"],
        why: "Perfetto per pouch e valigie: piega decente in trasferta senza sacrificare troppo.",
        query: "phon compatto pieghevole viaggio 1600w",
        image:
          "https://images.unsplash.com/photo-1522338140262-f46f5913618a?q=85&w=1000&auto=format&fit=crop",
      },
      {
        name: "Pettine a denti larghi in corno vegetale",
        price: "€ 18,00",
        priceRange: "€15–22",
        rating: "4.7",
        pros: ["Antistatico naturale", "Non spezza il capello bagnato", "Estetica elegante"],
        cons: ["Costa più del corrispettivo in plastica"],
        why: "L'oggetto post-doccia. Meno rotture, meno crespo.",
        query: "pettine denti larghi corno vegetale",
        image:
          "https://images.unsplash.com/photo-1579080788231-f9d1d71f6f50?q=85&w=1000&auto=format&fit=crop",
      },
    ],
    faq: [
      {
        q: "La ceramica fa davvero la differenza?",
        a: "Sì, per l'asciugatura con phon: distribuisce il calore in modo più uniforme. Per la sola spazzolatura a secco l'effetto è marginale.",
      },
      {
        q: "Meglio phon compatto o fisso?",
        a: "Fisso a casa se lo usi ogni giorno. Compatto solo per trasferte: la potenza inferiore si sente su lunghezze importanti.",
      },
    ],
  },
  {
    slug: "beauty-station-bagno-piccolo",
    title: "Beauty station per bagno piccolo",
    kicker: "Lista aggiornata — Novembre 2025",
    intro:
      "Cinque pezzi che compongono una beauty station credibile in meno di due metri lineari. Tutto sopra 4★, spedizione veloce, materiali resistenti all'umidità.",
    criteria: [
      "Adatto a spazi < 4 m²",
      "Materiali resistenti all'umidità (metallo, vetro, ceramica)",
      "Almeno 4★",
      "Spedizione veloce",
    ],
    cover:
      "https://images.unsplash.com/photo-1760749124145-8ceea3f541b5?q=85&w=1800&auto=format&fit=crop",
    products: [
      {
        name: "Mensola sopra lavandino in metallo nero",
        price: "€ 39,00",
        priceRange: "€35–50",
        rating: "4.5",
        pros: ["Salva spazio", "Estetica editorial", "Facile da montare"],
        cons: ["Fissaggio a parete"],
        why: "Sposta i prodotti dal piano al muro. Cambia la percezione dello spazio.",
        query: "mensola sopra lavandino metallo nero",
        image:
          "https://images.unsplash.com/photo-1595515770345-0497f6f13692?q=85&w=1000&auto=format&fit=crop",
      },
      {
        name: "Flaconi dispenser in vetro fumé 250ml (set 4)",
        price: "€ 26,00",
        priceRange: "€22–32",
        rating: "4.7",
        pros: ["Vetro spesso", "Pompa fluida", "Etichette minimal incluse"],
        cons: ["Da lavare prima del primo uso"],
        why: "Il gesto singolo che dà il look hotel a qualsiasi bagno.",
        query: "flaconi dispenser vetro fume 250ml set",
        image:
          "https://images.unsplash.com/photo-1540555700478-4be289fbecef?q=85&w=1000&auto=format&fit=crop",
      },
      {
        name: "Porta-spazzolino magnetico a parete",
        price: "€ 14,50",
        priceRange: "€12–18",
        rating: "4.4",
        pros: ["Libera il piano", "Igienico", "Installazione con biadesivo"],
        cons: ["Compatibile solo con spazzolini elettrici in metallo o con adattatore"],
        why: "Toglie l'oggetto più visivamente rumoroso dal piano lavandino.",
        query: "porta spazzolino magnetico parete",
        image:
          "https://images.unsplash.com/photo-1607613009820-a29f7bb81c04?q=85&w=1000&auto=format&fit=crop",
      },
      {
        name: "Cesta piccola in rattan naturale",
        price: "€ 19,00",
        priceRange: "€16–24",
        rating: "4.5",
        pros: ["Materiale naturale", "Contiene asciugamani arrotolati", "Duratura"],
        cons: ["Va tenuta lontana dal getto diretto della doccia"],
        why: "L'oggetto morbido che rompe il metallo/vetro e rende il bagno più caldo.",
        query: "cesta piccola rattan naturale bagno",
        image:
          "https://images.unsplash.com/photo-1578678809626-a3741782f0b8?q=85&w=1000&auto=format&fit=crop",
      },
      {
        name: "Sgabello legno chiaro impermeabilizzato",
        price: "€ 58,00",
        priceRange: "€50–70",
        rating: "4.6",
        pros: ["Doppia funzione (seduta + appoggio)", "Legno trattato per umidità", "Estetica calda"],
        cons: ["Va oliato ogni sei mesi"],
        why: "Chiude la beauty station: dove appoggi asciugamano, phon, prodotti in uso.",
        query: "sgabello legno chiaro bagno impermeabilizzato",
        image:
          "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?q=85&w=1000&auto=format&fit=crop",
      },
    ],
    faq: [
      {
        q: "Il rattan va bene in bagno?",
        a: "Sì, se non riceve schizzi diretti. Tienilo lontano dalla doccia e non appoggiarlo mai su superfici bagnate.",
      },
      {
        q: "Devo bucare la parete per la mensola?",
        a: "Dipende dal modello: alcune sono con biadesivo per tegole ceramiche fino a 5kg, altre richiedono tasselli. Verifica sempre prima dell'acquisto.",
      },
    ],
  },
  {
    slug: "best-of-under-30",
    title: "Best of Under €30",
    kicker: "Lista aggiornata — Novembre 2025",
    intro:
      "Cinque acquisti sotto i trenta euro con il miglior rapporto durata-prezzo. Tutti sopra 4 stelle, tutti con spedizione veloce, nessuno con claim medici.",
    criteria: [
      "Prezzo < €30",
      "Almeno 4★ con ≥300 recensioni",
      "Spedizione veloce",
      "Nessun claim medico o dermatologico",
    ],
    cover:
      "https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?q=85&w=1800&auto=format&fit=crop",
    products: [
      {
        name: "Rullo viso in acciaio freddo",
        price: "€ 19,90",
        priceRange: "€17–25",
        rating: "4.5",
        pros: ["Zero manutenzione", "Sensazione fresca", "Massaggio contorno occhi"],
        cons: ["Non è un dispositivo medicale"],
        why: "Un gesto piacevole al mattino. Nessuna promessa: solo freschezza reale.",
        query: "rullo viso acciaio freddo",
        image:
          "https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?q=85&w=1000&auto=format&fit=crop",
      },
      {
        name: "Pennello viso multiuso in fibre sintetiche",
        price: "€ 14,00",
        priceRange: "€10–18",
        rating: "4.6",
        pros: ["Facile da lavare", "Multiuso reale", "Duraturo"],
        cons: ["Da sostituire ogni 12–18 mesi"],
        why: "Il pennello che sostituisce tre pennelli. Perfetto per iniziare o per il travel.",
        query: "pennello viso multiuso fibre sintetiche",
        image:
          "https://images.unsplash.com/photo-1620804464794-d0410e95fbe5?q=85&w=1000&auto=format&fit=crop",
      },
      {
        name: "Pouch trasparente TPU doppia zip",
        price: "€ 12,50",
        priceRange: "€10–16",
        rating: "4.7",
        pros: ["Airport-friendly", "Impermeabile", "Vedi tutto in un colpo d'occhio"],
        cons: ["Meno protettiva di una pouch imbottita"],
        why: "La pouch giusta per la routine da 3 notti — anche solo per la palestra.",
        query: "pouch trasparente TPU doppia zip beauty",
        image:
          "https://images.unsplash.com/photo-1513127832320-b594b8bc38f3?q=85&w=1000&auto=format&fit=crop",
      },
      {
        name: "Set 6 mini-flaconi da viaggio 100 ml",
        price: "€ 11,00",
        priceRange: "€9–14",
        rating: "4.5",
        pros: ["Silicone morbido", "Non gocciolano", "Etichette resistenti"],
        cons: ["Da lavare bene dopo prodotti oleosi"],
        why: "Coppia perfetta con la pouch: la routine intera passa il controllo di sicurezza.",
        query: "mini flaconi viaggio 100ml silicone",
        image:
          "https://images.unsplash.com/photo-1701686794670-379e5a943a96?q=85&w=1000&auto=format&fit=crop",
      },
      {
        name: "Specchietto pieghevole tascabile in metallo",
        price: "€ 15,00",
        priceRange: "€12–20",
        rating: "4.6",
        pros: ["Doppio ingrandimento", "Compatto", "Materiale premium"],
        cons: ["Da riporre nella pouch per non graffiarsi"],
        why: "L'oggetto piccolo che alza tutta la pouch. Doppio ingrandimento serve davvero.",
        query: "specchietto pieghevole tascabile metallo",
        image:
          "https://images.unsplash.com/photo-1737014976491-9d4f2cc243ff?q=85&w=1000&auto=format&fit=crop",
      },
    ],
    faq: [
      {
        q: "Sotto €30 vale davvero la pena?",
        a: "Per accessori sì. Per tool elettrici (piastre, phon di qualità) spesso no: la fascia €40–80 è più onesta in termini di durata.",
      },
      {
        q: "I mini-flaconi in silicone durano?",
        a: "In media 2–3 anni con un uso corretto. Vanno lavati a fondo dopo prodotti oleosi altrimenti il silicone assorbe odori.",
      },
    ],
  },
];

export function getGuide(slug) {
  return GUIDES.find((g) => g.slug === slug);
}

export function getProductList(slug) {
  return PRODUCT_LISTS.find((p) => p.slug === slug);
}

export function getCategory(slug) {
  return CATEGORIES.find((c) => c.slug === slug);
}

// Attach commerce URLs
export function withProductUrl(product) {
  return { ...product, url: productSearch(product.query) };
}
